import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductSerialService {

  constructor(private httpClientService:HttpClientService) { }

  async createProductSerail(serialNo:string,productId:number){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.ProductSerial
    },{
      productSerial: serialNo,
      productId : productId
    });
    return await firstValueFrom(observable);
  }
  async updateProductSerial(id,productSerialNo,productId){
    const observable: Observable<any> = this.httpClientService.put({
      controller:ControllerType.ProductSerial
    },{
      id:id,
      productSerial:productSerialNo,
      productId:productId
    });
    return await firstValueFrom(observable);
  }

  async removeProductSerial(id){
    const observable:Observable<any> = this.httpClientService.delete({
      controller:ControllerType.ProductSerial
    },id);
    return await firstValueFrom(observable);
  }
}
